var React = require('react');

function Hexo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m128.039402 0-127.46412812 73.767737.01559017 147.311384 127.75449495 73.464699 127.464137-73.768712.001496-147.2300134-127.771556-73.5450946z","fill":"#0e83cd","key":0}),React.createElement("path",{"d":"m68.2420989 211.051307.0096072-63.701044.0096072-63.701052 11.573225-6.7680728 11.0855709 6.5598941.1195951 26.0306207.1195894 26.030614h37.0378963 37.037896l.119589-26.013515.119578-26.0135209 11.257574-6.5048985 11.412353 6.6788784-.005752 63.658884-.005753 63.658876-11.297988 6.310808-11.360676-6.392504-.119658-25.885673-.11967-25.885684h-37.037896-37.037896l-.1196584 25.878361.0342292 26.007943-11.3604459 6.662461z","fill":"#fff","key":1})]);
}

Hexo.defaultProps = {"height":"295","preserveAspectRatio":"xMidYMid","viewBox":"0 0 256 295","width":"256"};

module.exports = Hexo;

Hexo.default = Hexo;
